import { Tooltip } from 'antd';

export function CellErrorsIndicator(props: { errors?: string[] }) {
  const color = '#f5222d';
  const errors = props.errors?.filter(e => e !== 'Zorunlu alan');

  if (!errors?.length) {
    return null;
  }

  return (
    <Tooltip title={errors?.join('\n')}>
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          backgroundColor: color,
          height: '1rem',
          paddingLeft: '2px',
          paddingRight: '2px',
          margin: '0 2px',
          color: '#ffffff',
          fontSize: '0.6rem',
          fontWeight: 'bold',
        }}
      >
        {errors?.length || null}
      </div>
    </Tooltip>
  );
}
